import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../../api";
import urls from "../../../../urls";
import type { MeteringServiceProvider } from "../../../../utils/backend-types";

function useMeteringServiceProviderMutations() {
  const queryClient = useQueryClient();

  const updateMutation = useMutation({
    mutationFn: ({
      id,
      newData
    }: {
      id: MeteringServiceProvider["id"];
      newData: MeteringServiceProvider;
    }) => updateMSB(id, newData),
    onSuccess: handleSuccess
  });

  function handleSuccess(data: { data: MeteringServiceProvider }) {
    return queryClient.invalidateQueries({
      queryKey: ["metering-service-providers", { id: data.data.id }]
    });
  }

  return { updateMutation };
}

function updateMSB(
  id: MeteringServiceProvider["id"],
  newMSBData: MeteringServiceProvider
) {
  return api.patch(urls.api.meteringServiceProvider(id), newMSBData);
}

export { useMeteringServiceProviderMutations };
